import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/muniraj-profile.png";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and over time, I&apos;ve gained
              solid experience.
              <br />
              <br />
              I&apos;m fluent in core technologies like{" "}
              <i>
                <b className="purple">
                  PHP, Laravel, JavaScript, and React.js
                </b>
              </i>
              .
              <br />
              <br />
              I specialize in building&nbsp;
              <i>
                <b className="purple">scalable web applications</b> using modern
                Laravel practices, including tools like{" "}
                <b className="purple">Filament</b> for admin panels.
              </i>
              <br />
              <br />
              On the frontend, I enjoy creating dynamic UIs using{" "}
              <i>
                <b className="purple">React.js</b> and{" "}
                <b className="purple">Next.js</b>.
              </i>
              <br />
              <br />
              I&apos;m passionate about clean code, reusable components, and
              full-stack development.
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid rounded shadow"
                alt="Muniraj M"
              />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Let&apos;s connect and grow together!{" "}
              <span className="purple">Follow me</span> on:
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Muniraj132"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="GitHub"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://x.com/Muniraj2509"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="X (Twitter)"
                >
                  <span style={{ fontWeight: "bold" }}>𝕏</span>
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/muniraj0925/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.instagram.com/mr.unique.souls/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="Instagram"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
